import useRequestor from './useRequestor';

const useAccountServiceRequestor = () => {
	const { requestorId, tenantId, realmToken } = useRequestor();

	return {
		requestorId,
		accountServiceHeaders: {
			Authorization: `Bearer ${realmToken}`,
			'X-Tenant-Id': tenantId,
		},
	};
};

export default useAccountServiceRequestor;
